$(document).ready(function(){
	// Calender Display
	$('#example2').calendar({
	  on : 'hover',
	  type: 'date',
	  formatter: {
        date: function (date, settings) {
            if (!date) return '';
            var day = date.getDate();
            if (day.length < 2) {
                day = '0' + day;
            }
            var month = (date.getMonth() + 1) + '';
            if (month.length < 2) {
                month = '0' + month;
            }
            var year = date.getFullYear();
            return year + '-' + month + '-' + day;
        }
    }
	});

	$('#exp-date').calendar({
	  on : 'hover',
	  type: 'date',
	  formatter: {
        date: function (date, settings) {
            if (!date) return '';
            var day = date.getDate();
            if (day.length < 2) {
                day = '0' + day;
            }
            var month = (date.getMonth() + 1) + '';
            if (month.length < 2) {
                month = '0' + month;
            }
            var year = date.getFullYear().toString().substr(-2);
            return month + '/' + year ;
        }
    }
	});
	// Select Dropdown
	$('.ui.dropdown')
 	 .dropdown()
	;



	$('section#student-dashboard .column.dashboard .image, tbody a.ui.image')
		.dimmer({
		    on: 'hover'
		  })
		;
		
	$('.trigger.accordion')
		  .accordion({
		    selector: {
		      trigger: '.title .icon',
		    }
		  })
		  .accordion({
		    selector: {
		      trigger: '.title',
		    }
		  })
		;

	$('.ui.sidebar')
	  .sidebar('attach events', '.sidebar.icon')
	;

	$('.ui.sticky')
  .sticky({
    context: '#unity-exam-dashboard'
  })
;

	// For Print Document
	$('.forprint').on('click', function(){
		window.print();
	});

	$("button.pseudo-batch-file").on("click", function(e) {
			$this = $(this),
			inputFile = $this.closest('div.ui.action').next('input.batch-file');
		   $(inputFile).click(); 
		});

	$('input.batch-file').on('change', function(e){
		var $this = $(this),
			path = $this.val().split('\\'),
			filename = path[(path.length - 1)],
			pseudoFile = $this.prev('div.ui.action').find('input.pseudo-batch-file-name').eq(0);
			$(pseudoFile).val(filename);

			//$('input.pseudo-batch-file-name').val();
	});

	$("input.fileUpload").on('change', function () {
		//Get count of selected files
		var parent = $(this).parent();
		var countFiles = $(this)[0].files.length;
	
		var imgPath = $(this)[0].value;
		var extn = imgPath.substring(imgPath.lastIndexOf('.') + 1).toLowerCase();
		var image_holder = $(this).parent().find('.image-handler');
		image_holder.empty();
	
		if (extn == "gif" || extn == "png" || extn == "jpg" || extn == "jpeg") {
			if (typeof (FileReader) != "undefined") {
	
				//loop for each file selected for uploaded.
				for (var i = 0; i < countFiles; i++) {
	
					var reader = new FileReader();
					reader.onload = function (e) {
						$("<img />", {
							"src": e.target.result,
							"class": "ui fluid image"
						}).appendTo(image_holder);
					}
	
					image_holder.show();
					reader.readAsDataURL($(this)[0].files[i]);
				}
	
			} else {
				alert("This browser does not support FileReader.");
			}
		} else {
			alert("Pls select only images");
		}
	});

	// setTimeout(function(){
	// 	$('div.ui.floated.message').transition('fly left');
	// }, 15000);

	$('td.std-view button.ui.labeled.blue, td.std-view button.ui.labeled.orange').on('click', function(e){
		var $this = $(this),
			stdID = $this.data('std-id'),
			urlData = location.href.split('/'),
			editURL = location.origin+'/admin/'+urlData[4]+'/edit/'+stdID,
			modalEdit = $('div#edit.ui.modal'),
			btnRow = $this.closest('tr');
			btnTdRow = $(btnRow).find('td'),
			headerTR = $this.closest('table').find('thead tr'),
			headerTitle = headerTR.find('th div');
			if(headerTitle.eq(0).text().trim() === 'S/N' || headerTR.find('th').eq(0).text().trim() == 'S/N'){
				var stdNameTD = $(btnTdRow.eq(1)),
					stdIMGTag = $(btnTdRow.eq(3)).find('img').eq(0);
			}else{
				
				var stdNameTD = $(btnTdRow.eq(0)),
					stdIMGTag = $(btnTdRow.eq(2)).find('img').eq(0);
			}

		var modalArchor = modalEdit.find('.actions a').eq(0),
			modalHeader = modalEdit.find('div.header').eq(0);

			if($this.data('href') != undefined){

				editURL = location.origin+$this.data('href').replace(location.origin, '');
			}

			if($this.data('item') != undefined){
				item = $this.data('item');
			}else{
				item = stdNameTD.text();
			}

			modalContentDes = modalEdit.find('.content div.description').eq(0);

			modalContentDImg = modalEdit.find('.content img.image').eq(0);

			if(modalEdit.hasClass('generate')){
				$(modalHeader).text(item.toUpperCase());
			}else{
				$(modalHeader).text('Edit '+item.toUpperCase());
			}


			$(modalContentDImg).attr('src', $(stdIMGTag).attr('src'));

			if($this.data('message') != undefined){
				$(modalContentDes).html('<p>'+ $this.data('message') +' '+item.toUpperCase()+'?</p>');
			}else{
				if(modalEdit.hasClass('generate')){
					$(modalContentDes).html('<p>'+ $this.data('messages')+'?</p>');
				}else{
					$(modalContentDes).html('<p>Are you sure you want to edit '+item.toUpperCase()+'?</p>');
				}
			}

			$(modalArchor).attr('href',editURL);

			modalEdit.modal('setting', 'transition', 'fly right')
	        .modal('show');


	});

	$('.message .close')
		  .on('click', function() {
		    $(this)
		      .closest('.message')
		      .transition('fade')
		    ;
		  })
		;

		setTimeout(function(){
			$('.notification-wrapper .message').not('.important').slideUp();
		}, 10000);


		$('.ui.toggle.checkbox.check-all').checkbox({
	    // check all children
		    onChecked: function() {
		      var $childCheckbox  = $(this).closest('thead').siblings('tbody').find('.checkbox.studentID');
		      $childCheckbox.checkbox('check');
		    },
		    // uncheck all children
		    onUnchecked: function() {
		      var $childCheckbox  = $(this).closest('thead').siblings('tbody').find('.checkbox.studentID');
		      $childCheckbox.checkbox('uncheck');
		    }
		  })
		;

		$('.ui.toggle.checkbox.studentID').checkbox({
		    // Fire on load to set parent value
		    fireOnInit : true,
		    // Change parent state on each child checkbox change
		    onChange   : function() {
		      var $parentCheckbox = $('.ui.toggle.checkbox.check-all'),
		        $checkbox       = $('.ui.toggle.checkbox.studentID'),
		        allChecked      = true,
		        allUnchecked    = true
		      ;
		      // check to see if all other siblings are checked or unchecked
		      $checkbox.each(function() {
		        if( $(this).checkbox('is checked') ) {
		          allUnchecked = false;
		        }
		        else {
		          allChecked = false;
		        }
		      });
		      // Check if the page has Scartch Card Delete Button
		      if($('.fluid.ui.scratch-card.button').length > 0){

		      	  var scratchCard = $('.fluid.ui.scratch-card.button');

			      if(!allUnchecked){
			      	scratchCard.removeClass('disabled');
			      }else{
			      	if(!scratchCard.hasClass('disabled')){
			      		scratchCard.addClass('disabled');
			      	}
			      }
		      }
		      // set parent checkbox state, but dont trigger its onChange callback
		      if(allChecked) {
		        $parentCheckbox.checkbox('set checked');
		      }
		      else if(allUnchecked) {
		        $parentCheckbox.checkbox('set unchecked');
		      }
		      else {
		        $parentCheckbox.checkbox('set indeterminate');
		      }
		    }
		  });

	//For the Delet Modal
	$('td.std-view button.ui.labeled.negative').on('click', function(e){
		var $this = $(this),
			stdID = $this.data('std-id'),
			urlData = location.href.split('/'),
			deleteURL = location.origin+'/admin/'+urlData[4]+'/delete/'+stdID,
			modalDelete = $('div#delete.ui.modal'),
			btnRow = $this.closest('tr'),
			btnTdRow = $(btnRow).find('td'),
			headerTR = $this.closest('table').find('thead tr'),
			headerTitle = headerTR.find('th div');
			if(headerTitle.eq(0).text().trim() === 'S/N' || headerTR.find('th').eq(0).text().trim() == 'S/N'){
				var stdNameTD = $(btnTdRow.eq(1)),
					stdIMGTag = $(btnTdRow.eq(3)).find('img').eq(0);
			}else{
				
				var stdNameTD = $(btnTdRow.eq(0)),
					stdIMGTag = $(btnTdRow.eq(2)).find('img').eq(0);
			}
			var modalForm = modalDelete.find('form').eq(0),
			modalHeader = modalDelete.find('div.header').eq(0);

			modalContentDes = modalDelete.find('.content div.description').eq(0);

			modalContentDImg = modalDelete.find('.content img.image').eq(0);

			if($this.data('href') != undefined){
				deleteURL = location.origin+$this.data('href').replace(location.origin, '');
			}

			if($this.data('item') != undefined){
				item = $this.data('item');
			}else{
				item = stdNameTD.text();
			}

			$(modalHeader).text('Delete '+item.toUpperCase());

			$(modalContentDImg).attr('src', $(stdIMGTag).attr('src'));

			if($this.data('message') != undefined){
				$(modalContentDes).html('<p>'+ $this.data('message') +' '+item.toUpperCase()+'?</p>');
			}else{

				$(modalContentDes).html('<p>Are you sure you want to delete '+item.toUpperCase()+'?</p>');
			}

			$(modalForm).attr('action',deleteURL);

			modalDelete.modal('setting', 'transition', 'fly right')
	        .modal('show');


	});

	$('#states-dropdown.ui.dropdown, .states-dropdown.ui.dropdown')
	.dropdown({
		onChange : function(){
			var $this = $(this);
			if($this.find('input[name=state_id]').length > 0){
				stateInput = $this.find('input[name=state_id]').eq(0);
			}else{
				stateInput = $this.find('input[name=school_state_id]').eq(0);	
			}
				fieldLGA = $('#field-lga');
				fieldLGA.addClass('loading');
			$.ajax({
		        url: stateInput.data('href'),
		        headers: {'X-CSRF-TOKEN': $('meta[name=csrf_token]').attr('content')},
		        data: {
		            state: stateInput.val()
		        },
		        type: 'POST',
		        datatype: 'JSON',
		        success: function (resp) {
		        	$('#state-lga').html(resp.stateLGAS);
		        	fieldLGA.removeClass('loading');
		        }
		    });
		}
	});

	$('#classes-dropdown.ui.dropdown')
	.dropdown({
		onChange : function(){
			var $this = $(this);
				if($('#classes-dropdown.ui.dropdown input[name=class_id]').length > 0){
					classInput = $this.find('input[name=class_id]').eq(0);
				}else{
					classInput = $this.find('input[name=next_class_id]').eq(0);
				}
				fieldARM = $('#field-arms');
				fieldARM.addClass('loading');
			$.ajax({
		        url: classInput.data('href'),
		        headers: {'X-CSRF-TOKEN': $('meta[name=csrf_token]').attr('content')},
		        data: {
		            class: classInput.val()
		        },
		        type: 'POST',
		        datatype: 'JSON',
		        success: function (resp) {
		        	$('#class-arms').html(resp.classARM);
		        	fieldARM.removeClass('loading');
		        }
		    });
		}
	});

	$('div#mobile-icon').on('click', function(e){
    $('div#mobile-menu-view').slideToggle();
});
if($('tr.added-row').length > 0){
	$('tbody tr.added-row').filter(':last-child').find('.ui.dropdown.selection.multiple').find('.text').addClass('default').text('Select Teacher');
}

	$('#wrap-slgas.ui.dropdown, .wrap-slgas.ui.dropdown')
	.dropdown({
		onChange : function(){
			var $this = $(this);

				if($this.hasClass('just-state-lga')){
					return false;
				}
				if($this.hasClass('school-wrap-slgas')){
					stateInput = $this.closest('div.field.field-lga').prev('div.field.states').find('div.states-dropdown').find('input[name=school_state_id]').eq(0);
				}else{

					stateInput = $this.closest('div.field#field-lga').prev('div.field.states').find('div#states-dropdown').find('input[name=state_id]').eq(0);
				}
				if($this.find('input[name=lga_id]').length > 0){
					lgaInput = $this.find('input[name=lga_id]').eq(0);
				}else{
					lgaInput = $this.find('input[name=school_lga_id]').eq(0);
				}
				$('#wrap-schools input[name=school]').val('');
				$('#wrap-schools div.text').text('Schools');
				fieldARM = $('#field-school');
				fieldARM.addClass('loading');
			$.ajax({
		        url: lgaInput.data('href'),
		        headers: {'X-CSRF-TOKEN': $('meta[name=csrf_token]').attr('content')},
		        data: {
		            state: stateInput.val(),
		            lga: lgaInput.val()
		        },
		        type: 'POST',
		        datatype: 'JSON',
		        success: function (resp) {

		        	$('#school-options-handler').html(resp.schoolDisplay);
		        	fieldARM.removeClass('loading');
		        }
		    });
		}
	});

	$('#wrap-schools.ui.dropdown, .wrap-schools.ui.dropdown')
	.dropdown({
		onChange : function(){
			var $this = $(this);
				schoolInput = $this.find('input[name=school]').eq(0);
				fieldClass = $('#field-class');
				fieldHouse = $('#field-house');
				fieldSubject = $('#field-subject');
				if(fieldClass.length == 0 && fieldSubject.length == 0){
					return false;
				}
				fieldClass.addClass('loading');
				fieldHouse.addClass('loading');
				fieldSubject.addClass('loading');
			$.ajax({
		        url: schoolInput.data('href'),
		        headers: {'X-CSRF-TOKEN': $('meta[name=csrf_token]').attr('content')},
		        data: {
		            school: schoolInput.val()
		        },
		        type: 'POST',
		        datatype: 'JSON',
		        success: function (resp) {
		        	if($('#class-options-handler').length > 0){
			        	$('#class-options-handler').html(resp.classDisplay);
			        	fieldClass.removeClass('loading');
		        	}
		        	if($('#house-options-handler').length > 0){
			        	$('#house-options-handler').html(resp.houseDisplay);
			        	fieldHouse.removeClass('loading');
			        }
			        if($('#subject-options-handler').length > 0){
			        	$('#subject-options-handler').html(resp.subjectDisplay);
			        	fieldSubject.removeClass('loading');
			        }
		        }
		    });
		}
	});


	$(document.body).on('click','.wrap-subject.ui.dropdown', function(e){
		$parent_this = $(this);
		//To Show the dropdown of the added field
			if(!$parent_this.hasClass('active') && ($parent_this.find('input[type=hidden]').val() == '')){
				$parent_this.dropdown('show');
			}
			$parent_this.dropdown({
				onChange : function(text, value, element){
				var $this = $(this),
					subjectInput = $this.find('input[type=hidden]').eq(0),
					fieldTeacher = $this.closest('td').next('td').find('div.field');
					fieldTeacher.addClass('loading');

				$.ajax({
			        url: subjectInput.data('href'),
			        headers: {'X-CSRF-TOKEN': $('meta[name=csrf_token]').attr('content')},
			        data: {
			            subject_id: text
			        },
			        type: 'POST',
			        datatype: 'JSON',
			        success: function (resp) {
			        	fieldTeacher.find('.ui.dropdown.selection.multiple > a').remove();
			        	fieldTeacher.find('.ui.dropdown.selection.multiple').find('select').attr('name', resp.select_name);
			        	fieldTeacher.find('.ui.dropdown.selection.multiple').find('select').html(resp.teacher_display);
			        	fieldTeacher.find('.ui.dropdown.selection.multiple').find('div.menu').html(resp.teacher_div_option);
			        	fieldTeacher.removeClass('loading');
			        }
			    });
			}
			});

	});
// if($('.wrap-teacher.field .ui.dropdown.selection.multiple').length > 0){
// 	wrapTeacher = $('.wrap-teacher.field .ui.dropdown.selection.multiple');
// 	if(wrapTeacher.addEventListener){
// 	   wrapTeacher.addEventListener("click", function(e){
// 	   	console.log(e.target);
// 	   		$(e.target).closest('.ui.dropdown.selection.multiple').dropdown();
// 	   }, true);
// 	}elseif(wrapTeacher.attachEvent){
// 		wrapTeacher.attachEvent("onclick", function(e){
// 	       $(e.target).closest('.ui.dropdown.selection.multiple').dropdown();
// 	   });	
// 	}
// }

	$(document.body).on('click','.wrap-teacher.field .ui.dropdown.selection.multiple', function(e){
			$(e.target).closest('.ui.dropdown.selection.multiple').dropdown('show');
	});

	$('tfoot tr td.subject-action button').on('click', function(e){
		e.preventDefault();
		$this = $(this);
		if($this.hasClass('negative')){
			if($('tr.added-row').length > 1){
				$('tr.added-row').last().remove();
			}
		}else{
			$('tr.added-row')
				.last()
				.clone()
				.appendTo("tbody");
			$('tbody tr.added-row').filter(':last-child').find('.ui.dropdown.selection').not('.multiple').find('.text').addClass('default').text('Select Subject');
			$('tbody tr.added-row').filter(':last-child').find('.ui.dropdown.selection.multiple').find('.text').addClass('default').text('Select Teacher');
			$('tbody tr.added-row').filter(':last-child').find('.ui.dropdown.selection').not('.multiple').find('input[type=hidden]').val('');
			$('tbody tr.added-row').filter(':last-child').find('.ui.dropdown.selection.multiple > a').remove();

			//console.log($('tbody tr.added-row').filter(':last-child').find('.ui.dropdown.selection').not('.multiple').find('.text').text(''));
		}

	});

	/** Beginning of jSignature **/
	var $sigdiv = $("#signature");

	if($sigdiv.length > 0){
	$sigdiv.jSignature();

	$('canvas.jSignature').css({
		'background-color' : '#eeeeee',
		'width' : '100%'
	});

	$('[data-action=reset]').on('click', function(){

			$sigdiv.jSignature("reset"); // clears the canvas and rerenders the decor on it.
	});

	$('form button[type=submit]').on('click', function(e){
			//console.log($sigdiv.jSignature("getData", 'base30'));
			//$sigdiv.children("img.imported").remove();
			//$("<img class='imported'></img>").attr("src",$sigdiv.jSignature('getData', 'base30')).appendTo($sigdiv);
			if($sigdiv.jSignature('getData', 'native').length != 0){
				 $('form input[name=signature_png]').val($sigdiv.jSignature('getData'));

				 $('form.ui.form').submit();
			}else {
				e.preventDefault();
				window.alert('Sorry, the signature pad is empty');

			}

	});

	// Getting signature as SVG and rendering the SVG within the browser. 
	// (!!! inline SVG rendering from IMG element does not work in all browsers !!!)
	// this export plugin returns an array of [mimetype, base64-encoded string of SVG of the signature strokes]
	// var datapair = $sigdiv.jSignature("getData", "base30");
	// var i = new Image();
	// i.src = "data:" + datapair[0] + "," + datapair[1] ;
	// $(i).appendTo($("#someelement")); // append the image (SVG) to DOM.

	// Getting signature as "base30" data pair
	// array of [mimetype, string of jSIgnature"s custom Base30-compressed format]
	//datapair = $sigdiv.jSignature("getData","base30") 
	// reimporting the data into jSignature.
	// import plugins understand data-url-formatted strings like "data:mime;encoding,data"
	//$sigdiv.jSignature("setData", "data:" + datapair.join(","));

	} 
	// End of jSignature



	/**
 * Particleground
 *
 * @author Jonathan Nicol - @mrjnicol
 * @version 1.0.1
 * @description Creates a canvas based particle system background
 *
 * Inspired by:
 * http://requestlab.fr/
 * http://disruptivebydesign.com/
 *
 * @license The MIT License (MIT)
 *
 * Copyright (c) 2014 Jonathan Nicol - @mrjnicol
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
!function(a){function b(b,d){function e(){if(w){$canvas=a('<canvas class="pg-canvas"></canvas>'),v.prepend($canvas),p=$canvas[0],q=p.getContext("2d"),f();for(var b=Math.round(p.width*p.height/d.density),c=0;b>c;c++){var e=new l;e.setStackPos(c),x.push(e)}a(window).on("resize",function(){h()}),a(document).on("mousemove",function(a){y=a.pageX,z=a.pageY}),B&&!A&&window.addEventListener("deviceorientation",function(){D=Math.min(Math.max(-event.beta,-30),30),C=Math.min(Math.max(-event.gamma,-30),30)},!0),g(),o("onInit")}}function f(){p.width=v.width(),p.height=v.height(),q.fillStyle=d.dotColor,q.strokeStyle=d.lineColor,q.lineWidth=d.lineWidth}function g(){if(w){s=a(window).width(),t=a(window).height(),q.clearRect(0,0,p.width,p.height);for(var b=0;b<x.length;b++)x[b].updatePosition();for(var b=0;b<x.length;b++)x[b].draw();E||(r=requestAnimationFrame(g))}}function h(){for(f(),i=x.length-1;i>=0;i--)(x[i].position.x>v.width()||x[i].position.y>v.height())&&x.splice(i,1);var a=Math.round(p.width*p.height/d.density);if(a>x.length)for(;a>x.length;){var b=new l;x.push(b)}else a<x.length&&x.splice(a);for(i=x.length-1;i>=0;i--)x[i].setStackPos(i)}function j(){E=!0}function k(){E=!1,g()}function l(){switch(this.stackPos,this.active=!0,this.layer=Math.ceil(3*Math.random()),this.parallaxOffsetX=0,this.parallaxOffsetY=0,this.position={x:Math.ceil(Math.random()*p.width),y:Math.ceil(Math.random()*p.height)},this.speed={},d.directionX){case"left":this.speed.x=+(-d.maxSpeedX+Math.random()*d.maxSpeedX-d.minSpeedX).toFixed(2);break;case"right":this.speed.x=+(Math.random()*d.maxSpeedX+d.minSpeedX).toFixed(2);break;default:this.speed.x=+(-d.maxSpeedX/2+Math.random()*d.maxSpeedX).toFixed(2),this.speed.x+=this.speed.x>0?d.minSpeedX:-d.minSpeedX}switch(d.directionY){case"up":this.speed.y=+(-d.maxSpeedY+Math.random()*d.maxSpeedY-d.minSpeedY).toFixed(2);break;case"down":this.speed.y=+(Math.random()*d.maxSpeedY+d.minSpeedY).toFixed(2);break;default:this.speed.y=+(-d.maxSpeedY/2+Math.random()*d.maxSpeedY).toFixed(2),this.speed.x+=this.speed.y>0?d.minSpeedY:-d.minSpeedY}}function m(a,b){return b?void(d[a]=b):d[a]}function n(){v.find(".pg-canvas").remove(),o("onDestroy"),v.removeData("plugin_"+c)}function o(a){void 0!==d[a]&&d[a].call(u)}var p,q,r,s,t,u=b,v=a(b),w=!!document.createElement("canvas").getContext,x=[],y=0,z=0,A=!navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|BB10|mobi|tablet|opera mini|nexus 7)/i),B=!!window.DeviceOrientationEvent,C=0,D=0,E=!1;return d=a.extend({},a.fn[c].defaults,d),l.prototype.draw=function(){q.beginPath(),q.arc(this.position.x+this.parallaxOffsetX,this.position.y+this.parallaxOffsetY,d.particleRadius/2,0,2*Math.PI,!0),q.closePath(),q.fill(),q.beginPath();for(var a=x.length-1;a>this.stackPos;a--){var b=x[a],c=this.position.x-b.position.x,e=this.position.y-b.position.y,f=Math.sqrt(c*c+e*e).toFixed(2);f<d.proximity&&(q.moveTo(this.position.x+this.parallaxOffsetX,this.position.y+this.parallaxOffsetY),d.curvedLines?q.quadraticCurveTo(Math.max(b.position.x,b.position.x),Math.min(b.position.y,b.position.y),b.position.x+b.parallaxOffsetX,b.position.y+b.parallaxOffsetY):q.lineTo(b.position.x+b.parallaxOffsetX,b.position.y+b.parallaxOffsetY))}q.stroke(),q.closePath()},l.prototype.updatePosition=function(){if(d.parallax){if(B&&!A){var a=(s-0)/60;pointerX=(C- -30)*a+0;var b=(t-0)/60;pointerY=(D- -30)*b+0}else pointerX=y,pointerY=z;this.parallaxTargX=(pointerX-s/2)/(d.parallaxMultiplier*this.layer),this.parallaxOffsetX+=(this.parallaxTargX-this.parallaxOffsetX)/10,this.parallaxTargY=(pointerY-t/2)/(d.parallaxMultiplier*this.layer),this.parallaxOffsetY+=(this.parallaxTargY-this.parallaxOffsetY)/10}switch(d.directionX){case"left":this.position.x+this.speed.x+this.parallaxOffsetX<0&&(this.position.x=v.width()-this.parallaxOffsetX);break;case"right":this.position.x+this.speed.x+this.parallaxOffsetX>v.width()&&(this.position.x=0-this.parallaxOffsetX);break;default:(this.position.x+this.speed.x+this.parallaxOffsetX>v.width()||this.position.x+this.speed.x+this.parallaxOffsetX<0)&&(this.speed.x=-this.speed.x)}switch(d.directionY){case"up":this.position.y+this.speed.y+this.parallaxOffsetY<0&&(this.position.y=v.height()-this.parallaxOffsetY);break;case"down":this.position.y+this.speed.y+this.parallaxOffsetY>v.height()&&(this.position.y=0-this.parallaxOffsetY);break;default:(this.position.y+this.speed.y+this.parallaxOffsetY>v.height()||this.position.y+this.speed.y+this.parallaxOffsetY<0)&&(this.speed.y=-this.speed.y)}this.position.x+=this.speed.x,this.position.y+=this.speed.y},l.prototype.setStackPos=function(a){this.stackPos=a},e(),{option:m,destroy:n,start:k,pause:j}}var c="particleground";a.fn[c]=function(d){if("string"==typeof arguments[0]){var e,f=arguments[0],g=Array.prototype.slice.call(arguments,1);return this.each(function(){a.data(this,"plugin_"+c)&&"function"==typeof a.data(this,"plugin_"+c)[f]&&(e=a.data(this,"plugin_"+c)[f].apply(this,g))}),void 0!==e?e:this}return"object"!=typeof d&&d?void 0:this.each(function(){a.data(this,"plugin_"+c)||a.data(this,"plugin_"+c,new b(this,d))})},a.fn[c].defaults={minSpeedX:.1,maxSpeedX:.7,minSpeedY:.1,maxSpeedY:.7,directionX:"center",directionY:"center",density:1e4,dotColor:"#666666",lineColor:"#666666",particleRadius:7,lineWidth:1,curvedLines:!1,proximity:100,parallax:!0,parallaxMultiplier:5,onInit:function(){},onDestroy:function(){}}}(jQuery),/**
 * requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
 * @see: http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 * @see: http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
 * @license: MIT license
 */
function(){for(var a=0,b=["ms","moz","webkit","o"],c=0;c<b.length&&!window.requestAnimationFrame;++c)window.requestAnimationFrame=window[b[c]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[b[c]+"CancelAnimationFrame"]||window[b[c]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(b){var c=(new Date).getTime(),d=Math.max(0,16-(c-a)),e=window.setTimeout(function(){b(c+d)},d);return a=c+d,e}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(a){clearTimeout(a)})}();

$(function(){

    $('.jtr').particleground({
        minSpeedX: 0.1,
        maxSpeedX: 0.7,
        minSpeedY: 0.1,
        maxSpeedY: 0.7,
        directionX: 'center', // 'center', 'left' or 'right'. 'center' = dots bounce off edges
        directionY: 'center', // 'center', 'up' or 'down'. 'center' = dots bounce off edges
        density: 10000, // How many particles will be generated: one particle every n pixels
        dotColor: '#eee',
        lineColor: '#eee',
        particleRadius: 7, // Dot size
        lineWidth: 1,
        curvedLines: true,
        proximity: 100, // How close two dots need to be before they join
        parallax: false
    });

});
});